import React, { useState, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import { config } from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import { Col, Form, Row } from 'react-bootstrap';


export default function EmployeeSelector({onAccept, onClose}) {
  const [selectedItems, setSelectedItems] = useState(null);
  const [items, setItems] = useState([]);
  const [filterItems, setFilterItems] = useState([]);


  const [searchText, setSearchText] = useState("");
  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);
  const LoadingRows = Array.from({length:5});

  useEffect(() => {
    searchEmployeeis();
  }, []);

  const searchEmployeeis = function () {
    var sText = "";
    if (searchText != null) {
      sText = searchText;
    }
    var params = { login: util.getTrustedUser(), lastIndex: 0, pageSize: 0, includeTeacher:true, includeAssistant:true, searchText: sText };
    var url = config.Server + `/user/school/user/list`;
      console.log("params is>", params);
      console.log("url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  console.log("response is>", response);
                  
                  setItems(response);
                  setFilterItems(response);
                  
                  setLoading(false);
                  
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });

  }
  const onInputChange = function(e, name){
    var val = '';
    val = (e.target && e.target.value) || '';
    if(name === "searchText")setSearchText(val);
  }
  const closeSelectStudentDialog = function () {
    onClose();
  }
  const saveItem = function () {
    if(selectedItems == null){
      setErorVisible(true);
      setErrorMessage("هیچ موردی انتخاب نشد است");
      return;
    }
    if(selectedItems.length === 0){
      setErorVisible(true);
      setErrorMessage("هیچ موردی انتخاب نشد است");
      return;
    }
    onAccept(selectedItems);
  }
  const selectStudentDialogFooter = function () {
    return (
      <GeneralDialogFooter onOkClick={() => { saveItem() }} onCancelClick={() => { closeSelectStudentDialog() }} saving={saving} />
    )
  }

  return (
    <>
      <Dialog visible={true} style={{ width: '90%' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
                  header="جستجو و انتخاب همکار" modal className="p-fluid" footer={() => selectStudentDialogFooter()} onHide={() => closeSelectStudentDialog()}>
        <div style={{backgroundColor:"#d6d6d6ff", borderRadius:"5px", margin:"10px -15px 0px -15px", display:'flow-root'}}>
          <Row style={{margin:"0px "}}>
            <Col md={3} style={{padding:"15px 10px 0px 10px"}}>
              <FloatLabel>
                  <InputText value={searchText} onChange={(e)=>{onInputChange(e, "searchText")}} id="searchText" keyfilter="" maxLength={50} className="p-inputtext-lg" style={{textAlign:"center", padding:'10px'}} />
                  <label htmlFor="username">جستجو</label>
              </FloatLabel>
            </Col>
            <Col md={3}>
              <div style={{float:'right', paddingTop:'10px', margin:'5px', display:'block', height:"75px", direction:"ltr", textAlign:"right"}}>
                <Button label="مشاهده" icon="pi pi-search" onClick={()=>searchEmployeeis()} severity="primary" iconPos="right" />
              </div>        
            </Col>
          </Row>
        </div>

        {
          loading?
          <DataTable value={LoadingRows}  className="p-datatable-striped">
              <Column field="id" header="کد" style={{ width: '20%' }} body={<Skeleton />}></Column>
              <Column field="title" header="عنوان" style={{ width: '80%' }} body={<Skeleton />}></Column>
          </DataTable>
          :
          <>
            <div className='col-12' style={{overflowX:"scroll", width:"calc(100% + 30px)", marging:"0px -15px"}}>
                <DataTable value={filterItems} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{ minWidth: '50rem' }} size="small" stripedRows paginator rows={50} rowsPerPageOptions={[50, 100, 200, 500]}
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" 
                currentPageReportTemplate="{first} تا {last} از {totalRecords}"
                dataKey="id"  selection={selectedItems}  onSelectionChange={(e) => {setSelectedItems(e.value)}}>
                    <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                    <Column header="#" headerStyle={{ width: '3rem' }} body={(data, options) => options.rowIndex + 1}  className="list-cell-text-align"></Column>
                    {config.ShowListId? <Column field="id" header={"شناسه"} sortable className="list-cell-text-align"></Column>: <></>} 
                    <Column field="user.nationalId" body={(row) => row.user.nationalId} header={"کدملی"} sortable className="list-cell-text-align"></Column>
                    <Column field="user.firstname" body={(row) => row.user.firstname} header={"نام"} sortable className="list-cell-text-align"></Column>
                    <Column field="user.lastname" body={(row) => row.user.lastname} header={"نام خانوادگی"} sortable className="list-cell-text-align"></Column>
                    <Column field="user.mobile" body={(row) => row.user.mobile} header={"شماره تلفن"} sortable className="list-cell-text-align"></Column>
                </DataTable>
            </div>
          </>
        }

      </Dialog>




      <ShowError visible={errorVisible} message={errorMessage} closeError={() => { setErorVisible(false) }} />
    </>
  );
}
